import { jsx as e } from "react/jsx-runtime";
import { forwardRef as i } from "react";
import m from "./styles.module.less.js";
const a = i((r, o) => {
  var t;
  const { text: s } = r;
  return /* @__PURE__ */ e("div", { ref: o, ...r.props, className: `${m.inputDescription} ${((t = r.props) == null ? void 0 : t.className) || ""}`, children: s });
});
export {
  a as InputDescription
};
